var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniRestaurant04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.648438,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#4A5294"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_502_15564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.648438,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_502_15564)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 187.073,
    cy: 128.944,
    r: 87.0244,
    fill: "#261252"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.541,
    cy: 126.836,
    r: 83.0719,
    fill: "#FFFBF8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.612,
    cy: 126.835,
    r: 54.7645,
    fill: "#FFFBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.612 72.0703C164.367 72.0703 139.848 96.5892 139.848 126.835C139.848 135.334 141.784 143.382 145.239 150.56C134.496 102.349 185.934 59.7787 234.298 89.0967C224.322 78.6083 210.23 72.0703 194.612 72.0703Z",
    fill: "#EBE3DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.66 150.22C237.974 145.471 238.733 140.265 241.682 136.48C247.242 129.346 250.572 120.26 250.572 110.366C250.572 87.4274 232.671 68.832 210.589 68.832C188.507 68.832 170.605 87.4274 170.605 110.366C170.605 123.949 176.882 136.009 186.588 143.587C189.52 145.877 190.988 149.661 190.988 153.381V153.381C190.988 166.018 201.711 176.263 214.938 176.263C228.165 176.263 238.887 166.018 238.887 153.381C238.887 152.308 238.81 151.253 238.66 150.22Z",
    fill: "#ECDACD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.506 148.887C235.819 144.138 236.578 138.931 239.528 135.146C245.087 128.012 248.418 118.926 248.418 109.032C248.418 86.0934 230.517 67.498 208.434 67.498C186.352 67.498 168.451 86.0934 168.451 109.032C168.451 122.615 174.728 134.675 184.432 142.253C187.365 144.543 188.834 148.328 188.834 152.049V152.049C188.834 164.686 199.556 174.931 212.783 174.931C226.01 174.931 236.733 164.686 236.733 152.049C236.733 150.976 236.656 149.92 236.506 148.887Z",
    fill: "#FFF2E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.432,
    cy: 101.162,
    r: 18.1801,
    fill: "#FFA462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.434 119.342C218.474 119.342 226.614 111.202 226.614 101.162C226.614 98.0763 225.845 95.1704 224.489 92.625C226.585 101.144 225.268 118.264 203.227 118.585C204.876 119.077 206.624 119.342 208.434 119.342Z",
    fill: "#C47740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.624 88.2486C201.377 89.1098 196.4 94.0186 195.39 101.654C195.296 102.365 194.628 102.875 193.926 102.727C193.38 102.612 192.984 102.129 193.015 101.571C193.489 93.146 200.166 86.3784 208.552 85.7625C209.24 85.712 209.801 86.276 209.801 86.9658C209.801 87.628 209.282 88.1704 208.624 88.2486Z",
    fill: "#FFD0AE",
    fillOpacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.03 75.6071C188.719 78.1161 180.83 86.2949 178.452 93.8147C178.202 94.606 177.346 95.0707 176.571 94.7735C175.932 94.5284 175.573 93.8439 175.772 93.1894C178.557 84.0399 186.837 76.326 195.418 73.308C195.862 73.1518 196.353 73.3015 196.649 73.6683C197.181 74.3292 196.832 75.3317 196.03 75.6071Z",
    fill: "#FFFBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.316 242.311V222.514H190.082C194.58 222.514 197.164 225.289 197.164 229.186C197.164 233.137 194.539 235.857 189.973 235.857H186.418V242.311H182.316ZM186.418 232.549H189.316C191.75 232.549 192.939 231.182 192.926 229.186C192.939 227.217 191.75 225.891 189.316 225.877H186.418V232.549ZM201.129 242.557C199.844 242.557 198.805 241.531 198.832 240.26C198.805 239.002 199.844 237.977 201.129 237.99C202.346 237.977 203.398 239.002 203.398 240.26C203.398 241.531 202.346 242.557 201.129 242.557ZM206.734 242.311V222.514H214.5C218.998 222.514 221.582 225.289 221.582 229.186C221.582 233.137 218.957 235.857 214.391 235.857H210.836V242.311H206.734ZM210.836 232.549H213.734C216.168 232.549 217.357 231.182 217.344 229.186C217.357 227.217 216.168 225.891 213.734 225.877H210.836V232.549ZM228.145 222.514V242.311H224.098V222.514H228.145ZM238.016 242.611C233.463 242.598 230.674 239.658 230.688 234.955C230.674 230.375 233.504 227.271 237.852 227.271C241.748 227.271 244.824 229.732 244.824 234.791V235.939H234.68C234.68 238.182 236.006 239.562 238.098 239.576C239.479 239.562 240.463 238.961 240.859 238.072H244.715C244.141 240.82 241.68 242.598 238.016 242.611ZM234.68 233.396H240.996C240.982 231.592 239.738 230.293 237.934 230.307C236.074 230.293 234.762 231.688 234.68 233.396Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniRestaurant04);
export default __webpack_public_path__ + "static/media/mini_restaurant_04.2fd25557b0c585bb791587392d32a0ed.svg";
export { ForwardRef as ReactComponent };